var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React, { useState } from 'react';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { breakpoints } from '../utils/themes';
var AlertWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n  border: 0;\n  border-right: 5px solid ", ";\n  box-shadow: ", ";\n  display: flex;\n  margin: 1em 1em 2em 1em;\n  padding: 0;\n  position: relative;\n  transition: box-shadow 250ms ease-in-out;\n  &:hover {\n    box-shadow: ", ";\n    transition: box-shadow 250ms ease-in-out;\n  }\n"], ["\n  background-color: ", ";\n  border-radius: ", ";\n  border: 0;\n  border-right: 5px solid ", ";\n  box-shadow: ", ";\n  display: flex;\n  margin: 1em 1em 2em 1em;\n  padding: 0;\n  position: relative;\n  transition: box-shadow 250ms ease-in-out;\n  &:hover {\n    box-shadow: ", ";\n    transition: box-shadow 250ms ease-in-out;\n  }\n"])), function (p) {
  return p.theme[p.brand];
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.invert ? 'transparent' : p.theme[p.brand];
}, function (p) {
  return p.theme.boxShadow;
}, function (p) {
  return p.theme.boxShadowLarge;
});
var AlertIcon = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", " 0 0 ", ";\n  color: ", ";\n  display: flex;\n  padding: 0 1.25em;\n  position: relative;\n\n  &::after {\n    -moz-transform: scale(0.9999);\n    border-bottom: 11px solid transparent;\n    border-left: 11px solid\n      ", ";\n    border-top: 11px solid transparent;\n    color: ", ";\n    content: '';\n    height: 0;\n    margin-top: -10px;\n    position: absolute;\n    right: -11px;\n    top: 50%;\n    width: 0;\n    z-index: 2;\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", " 0 0 ", ";\n  color: ", ";\n  display: flex;\n  padding: 0 1.25em;\n  position: relative;\n\n  &::after {\n    -moz-transform: scale(0.9999);\n    border-bottom: 11px solid transparent;\n    border-left: 11px solid\n      ", ";\n    border-top: 11px solid transparent;\n    color: ", ";\n    content: '';\n    height: 0;\n    margin-top: -10px;\n    position: absolute;\n    right: -11px;\n    top: 50%;\n    width: 0;\n    z-index: 2;\n  }\n"])), function (p) {
  return p.invert ? p.theme.colorLevel(p.theme[p.brand], -5) : p.theme[p.brand];
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.invert ? p.theme.colorLevel(p.theme[p.brand], 3) : p.theme.white;
}, function (p) {
  return p.invert ? p.theme.colorLevel(p.theme[p.brand], -5) : p.theme[p.brand];
}, function (p) {
  return p.theme.white;
});
var AlertText = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-self: center;\n  background-color: ", ";\n  color: ", ";\n  flex-grow: 1;\n  font-weight: ", ";\n  margin: 0;\n  padding: 1.25em 1.5em;\n"], ["\n  align-self: center;\n  background-color: ", ";\n  color: ", ";\n  flex-grow: 1;\n  font-weight: ", ";\n  margin: 0;\n  padding: 1.25em 1.5em;\n"])), function (p) {
  return p.invert ? 'transparent' : p.theme.level3;
}, function (p) {
  return p.invert ? p.theme.white : p.theme.textSecondary;
}, function (p) {
  return p.theme.fontWeightBold;
});
var AlertClose = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  padding: 0 1em;\n\n  & > svg {\n    transform: scale(1);\n    transition: transform 100ms ease-in-out;\n  }\n\n  &:hover {\n    cursor: pointer;\n    & > svg {\n      transform: scale(1.2);\n      transition: transform 100ms ease-in-out;\n    }\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  padding: 0 1em;\n\n  & > svg {\n    transform: scale(1);\n    transition: transform 100ms ease-in-out;\n  }\n\n  &:hover {\n    cursor: pointer;\n    & > svg {\n      transform: scale(1.2);\n      transition: transform 100ms ease-in-out;\n    }\n  }\n"])), function (p) {
  return p.invert ? 'transparent' : p.theme.level3;
}, function (p) {
  return p.invert ? p.theme.white : p.theme.textSecondary;
});

var getIcon = function getIcon(brand) {
  switch (brand) {
    case 'success':
      return faCheck;

    case 'warning':
      return faExclamationTriangle;

    case 'danger':
      return faTimes;

    case 'info':
    default:
      return faExclamationCircle;
  }
};

var Alert = function Alert(_a) {
  var invert = _a.invert,
      brand = _a.brand,
      children = _a.children,
      onClick = _a.onClick;
  var width = window.innerWidth;

  var _b = useState(false),
      dismissed = _b[0],
      setDismissed = _b[1];

  if (!dismissed) {
    return React.createElement(AlertWrapper, {
      brand: brand || 'primary',
      className: "alert alert-" + brand + (invert ? '-invert' : ''),
      invert: invert,
      role: "alert"
    }, React.createElement(AlertIcon, {
      brand: brand || 'primary',
      className: "alert-icon",
      invert: invert
    }, React.createElement(FontAwesomeIcon, {
      icon: getIcon(brand),
      size: width > breakpoints.sm ? '2x' : 'lg',
      fixedWidth: true
    })), React.createElement(AlertText, {
      brand: brand || 'primary',
      className: "alert-text",
      invert: invert
    }, children), React.createElement(AlertClose, {
      brand: brand || 'primary',
      className: "alert-close",
      invert: invert,
      onClick: onClick ? function () {
        return onClick(setDismissed);
      } : function () {
        return setDismissed(true);
      }
    }, React.createElement(FontAwesomeIcon, {
      icon: faTimes,
      size: "lg",
      fixedWidth: true
    })));
  }

  return null;
}; //export default React.memo(Alert);


export default Alert;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;